export default __webpack_public_path__ + "010ccf9e7f63b4e8697f5cabb76babb9.png";